import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const END_POINT = '/users';

export default {
  async getCustomerList(payload) {
    const params = getParamsFormObject(payload);
    const path = END_POINT + params;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async exportCustomerFile(payload) {
    const params = getParamsFormObject(payload);
    const path = `${END_POINT}/export?${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getCustomerDetails(id) {
    const path = `${END_POINT}/${id}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async blockCustomer(id) {
    const path = `${END_POINT}/${id}/block`;

    const response = await axiosClient.put(path);

    return response.data;
  },

  async unblockCustomer(id) {
    const path = `${END_POINT}/${id}/unblock`;

    const response = await axiosClient.put(path);

    return response.data;
  },

  async updateCustomerLevel(id, payload) {
    const path = `${END_POINT}/${id}/level`;

    const response = await axiosClient.put(path, payload);

    return response.data;
  },

  async getCustomerBookings(payload) {
    const id = typeof payload === 'string' ? payload : payload.id;
    const paramsObj =
      typeof payload === 'object'
        ? {
          page: payload.page,
          limit: payload.limit,
          bookingStatus: payload.bookingStatus,
        }
        : {};
    const extraParams = getParamsFormObject(paramsObj);
    const path = `${END_POINT}/${id}/bookings${extraParams}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
